<script setup>
import { computed } from 'vue';

const props = defineProps({
  buttons: {
    type: Array,
    default: () => [],
  },
  interactive: {
    type: Boolean,
    default: false,
  },
  widgetColor: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['callback']);

const buttonKey = button => button.custom_id || button.customId;
const isUrl = button => button.type === 'url';

const buttonStyle = computed(() => {
  if (!props.widgetColor) return undefined;
  return { borderColor: props.widgetColor, color: props.widgetColor };
});

const onCallbackClick = button => {
  if (!props.interactive) return;
  emit('callback', button);
};
</script>

<template>
  <div class="flex flex-col gap-1 w-full max-w-64">
    <template v-for="button in buttons" :key="buttonKey(button)">
      <a
        v-if="isUrl(button)"
        :href="button.url"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="inline-flex items-center justify-center rounded-lg border border-n-brand px-3 py-2 text-sm font-medium text-n-brand no-underline bg-n-background dark:bg-n-solid-3"
        :style="buttonStyle"
      >
        {{ button.text }}
      </a>
      <button
        v-else-if="interactive"
        type="button"
        class="inline-flex items-center justify-center rounded-lg border border-n-brand px-3 py-2 text-sm font-medium text-n-brand bg-n-background dark:bg-n-solid-3"
        :style="buttonStyle"
        @click="onCallbackClick(button)"
      >
        {{ button.text }}
      </button>
      <div
        v-else
        class="inline-flex items-center justify-center rounded-lg border border-n-weak px-3 py-2 text-sm font-medium text-n-slate-11 bg-n-alpha-2"
      >
        {{ button.text }}
      </div>
    </template>
  </div>
</template>
